import { CommonModule } from '@angular/common';
import { Component, input, linkedSignal } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ErrorPipe } from './directives/error.directive';

@Component({
    selector: 'app-form-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
    imports: [CommonModule, ErrorPipe],
})
export class ErrorComponent {
    readonly errors = input<ValidationErrors | null>(null);
    readonly visible = input(false);

    readonly displayedErrors = linkedSignal<ValidationErrors | null, ValidationErrors | null>({
        source: this.errors,
        computation: (source, previous) => source ?? previous?.value ?? null,
    });
}
